import { Grid } from "@mui/material";
import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import PageTitle from "../../components/PageTitle";
import CardCount from "../../components/CardCount";
import Table from "../../components/Table/Table";
import Layout from "../../components/Layout";
import { httprequest } from "../../data/api";

const WALLET_SUMMARY_ENDPOINT = "/api/v1/points/student-wallet-summary";
const POINTS_ENDPOINT = "/api/v1/points/student-points";

const StudentReward = () => {
  const [walletData, setWalletData] = useState(null);
  const [tableData, setTableData] = useState([]);

  const getWalletSummary = async () => {
    try {
      const res = await httprequest.get(WALLET_SUMMARY_ENDPOINT);
      if (res?.data?.data) {
        setWalletData(res.data.data);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error fetching wallet summary", err);
    }
  };

  const getStudentPoints = async () => {
    try {
      const res = await httprequest.get(POINTS_ENDPOINT);
      if (res?.data?.data) {
        const pointsData = res.data.data.docs || res.data.data;

        if (Array.isArray(pointsData) && pointsData.length > 0 && pointsData[0].activities) {
          const flattenedHistory = [];
          pointsData.forEach((historyItem) => {
            historyItem.activities.forEach((activity) => {
              flattenedHistory.push({
                ...activity,
                date: historyItem.date
              });
            });
          });
          setTableData(flattenedHistory);
        } else {
          setTableData(Array.isArray(pointsData) ? pointsData : []);
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error fetching points data", err);
    }
  };

  useEffect(() => {
    getWalletSummary();
    getStudentPoints();
  }, []);

  const columns = [
    { name: "Teacher Name", selector: (row) => row.awarded_by_teacher, sortable: true },
    { name: "Points", selector: (row) => `+${row.points}`, sortable: true },
    { name: "Reason", selector: (row) => row.tag_name || row.reason || "N/A", sortable: true },
    { name: "Date", selector: (row) => new Date(row.timestamp).toLocaleDateString(), sortable: true }
  ];

  return (
    <Layout
      children={
        <div>
          <PageTitle
            title="Reward"
            subtitle="View points, understand how they were earned"
          />

          <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
            <Grid item xs={12} sm={6} md={3}>
              <CardCount
                title="Total Earned"
                count={`${walletData?.total_earned || 0} pts`}
                icon={<Icon icon="ph:trend-up-bold" width={30} />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardCount
                title="Available Points"
                count={`${walletData?.available_points || 0} pts`}
                icon={<Icon icon="ph:wallet-bold" width={30} />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardCount
                title="Maximum Withdrawal"
                count={`${walletData?.maximum_withdrawal || 0} pts`}
                icon={<Icon icon="ph:trend-down-bold" width={30} />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardCount
                title="Pending Points"
                count={`${walletData?.pending_points || 0} pts`}
                icon={<Icon icon="ph:clock-bold" width={30} />}
              />
            </Grid>
          </Grid>

          <div style={{ backgroundColor: "white", padding: "1rem", borderRadius: "8px" }}>
            <h6 style={{ marginBottom: "0.2rem", fontWeight: 600 }}>Earning History</h6>
            <p style={{ color: "#666", fontSize: "0.875rem", marginBottom: "1rem" }}>See how much you've earned so far</p>
            <Table
              data={tableData}
              columns={columns}
              pagination
            />
          </div>
        </div>
      }
    />
  );
};

export default StudentReward;
